module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tickets_page"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('app-tb-tickets'), _vm._v(" "), _c('app-tb-history')], 1), _vm._v(" "), _c('offer-use-open-id')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c8aefb9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tickets-and-bar/wrapper.vue
// module id = 418
// module chunks = 1